import EventStack from './EventStack';
var instance = new EventStack();
export default instance;


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/es/lib/eventStack/index.js
// module id = 2846
// module chunks = 0